import React, { useEffect, useState } from "react";
import trip from "../Accests/images/trip.png";
import instagram from "../Accests/Instagram_icon.png"; // Instagram icon path

const TripadvisorPopupButton = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setVisible(window.scrollY > 300);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            {visible && (
                <div className="fixed bottom-20 right-4 z-50 flex flex-col items-end gap-4">
                    {/* Instagram Icon Button */}
                    <button
                        onClick={() =>
                            window.open(
                                "https://www.instagram.com/no_limit_tour_randombe_/",
                                "_blank"
                            )
                        }
                        className="w-12 h-12 rounded-full bg-black flex items-center justify-center overflow-hidden animate-pulse hover:scale-110 transition-transform"
                    >
                        <img
                            src={instagram}
                            alt="Instagram"
                            className="w-full h-full object-cover"
                        />
                    </button>

                    {/* Tripadvisor Icon Button */}
                    <button
                        onClick={() =>
                            window.open(
                                "https://www.tripadvisor.com/Attraction_Review-g612378-d32787583-Reviews-No_Limit_Tour_Randombe-Ambalangoda_Galle_District_Southern_Province.html",
                                "_blank"
                            )
                        }
                        className="w-12 h-12 rounded-full flex items-center justify-center overflow-hidden animate-pulse hover:scale-110 transition-transform"
                    >
                        <img
                            src={trip}
                            alt="Tripadvisor"
                            className="w-full h-full object-cover"
                        />
                    </button>
                </div>
            )}
        </>
    );
};

export default TripadvisorPopupButton;
